import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bottomMenu" }
const _hoisted_2 = { class: "bottomMenu_wrapper" }
const _hoisted_3 = { class: "bottomMenu_header" }
const _hoisted_4 = { class: "bottomMenu_title" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "bottomMenu_checkbox"
}
const _hoisted_7 = {
  key: 1,
  class: "bottomMenu_chevron"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "bottomMenu_checkbox" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, {
    to: "#vjs-settings-menu",
    disabled: false
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "bottomMenu_overlay",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
      }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.menuType !== '')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "bottomMenu_back",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onBack && _ctx.onBack(...args)))
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.title), 1),
          _createElementVNode("div", {
            class: "bottomMenu_close",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
          })
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (_ctx.menuType === '')
              ? (_openBlock(), _createElementBlock("div", {
                  key: item.name,
                  class: _normalizeClass(["bottomMenu_label", {
              '-checked': item.selected
            }]),
                  onClick: ($event: any) => (_ctx.onClickItem(item))
                }, [
                  _createTextVNode(_toDisplayString(item.label) + " ", 1),
                  (item.type === 'checkbox')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                    : _createCommentVNode("", true),
                  (item.type === 'select')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_5))
              : _createCommentVNode("", true),
            (item.type)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.menuType === item.name)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.children, (itemChild) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: itemChild.name,
                          class: _normalizeClass(["bottomMenu_label", {
              '-checked': itemChild.selected
            }]),
                          onClick: ($event: any) => (_ctx.onClickItem(itemChild, item.name))
                        }, [
                          _createTextVNode(_toDisplayString(itemChild.label) + " ", 1),
                          _hoisted_9
                        ], 10, _hoisted_8))
                      }), 128))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ], 64))
        }), 256))
      ])
    ])
  ]))
}